import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

export const MultiCargoAdjustmentSchema: RegistryItem = {
	[AgreementTypeEnum.MultiCargoAdjustment]: {
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
	},
};
